import React, { useEffect } from 'react';
import SettingContainer from '../SettingContainer';
import { useConfig } from '../../../DataStore/ConfigContext';
import { useTheme } from '../../../DataStore/ThemeContext';

const SchoolProfile = () => {
  const { schoolProfile, getSchoolProfile } = useConfig();
  const { openSettings } = useTheme();

  useEffect(() => {
    getSchoolProfile();
  }, []);

  const handleEditProfile = () => {
     openSettings("Edit Profile", "EditSchoolProfile", schoolProfile);
  }

  const handleUploadBadge = () => {
     openSettings("Upload Badge", "UploadBadge");
  }

  const handleUploadSign = () => {
     openSettings("Upload Signature", "UploadSignature");
  }

  

  const menu = () => (
    <>
      <button type="button" tabIndex="0" className="dropdown-item" onClick={handleEditProfile}>
        <i className="dropdown-icon fa fa-edit"> </i><span>Edit Profile</span>
      </button>
       <button type="button" tabIndex="0" className="dropdown-item" onClick={handleUploadBadge}>
        <i className="dropdown-icon fa fa-shield" aria-hidden={true}> </i><span>Change Badge</span>
      </button>
      <button type="button" tabIndex="0" className="dropdown-item" onClick={handleUploadSign}>
        <i className="dropdown-icon fa fa-shield"> </i><span>Change Signature</span>
      </button>
      <button type="button" tabIndex="0" className="dropdown-item" onClick={() => getSchoolProfile(true)}>
        <i className="dropdown-icon fa fa-sync"> </i><span>Refresh</span>
      </button>
    </>
  );

  const ProfileCard = () => {
    if (!schoolProfile) return null;

    const {
      school_name,
      email_address,
      website,
      telephone,
      address,
      motto,
      badge,
      short_name,
      initials,
      signature_title,
      sign,
    } = schoolProfile;

    return (
      <div className="card shadow-sm border-0">
        <div className="card-body">
          <div className="row">
            <div className="col-md-3 text-center">
              {badge ? (
                <img
                  src={badge}
                  alt="School Badge"
                  className="img-fluid rounded mb-3 border"
                  style={{ maxHeight: '140px' }}
                />
              ) : (
                <div className="border rounded py-5 text-muted">No Badge</div>
              )}
              <h5 className="mt-3 mb-0">{short_name} <small className="text-muted">({initials})</small></h5>
              <small className="text-muted">"{motto}"</small>
            </div>

            <div className="col-md-9">
              <div className="table-responsive">
                <table className="table table-sm table-borderless">
                  <tbody>
                    <tr>
                      <th style={{ width: '150px' }}>School Name:</th>
                      <td>{school_name}</td>
                    </tr>
                    <tr>
                      <th>Email:</th>
                      <td>{email_address}</td>
                    </tr>
                    <tr>
                      <th>Telephone:</th>
                      <td>{telephone}</td>
                    </tr>
                    <tr>
                      <th>Address:</th>
                      <td>{address}</td>
                    </tr>
                    <tr>
                      <th>Website:</th>
                      <td>{website || <span className="text-muted">Not Provided</span>}</td>
                    </tr>
                    <tr>
                      <th>Signature:</th>
                      <td>
                        {sign ? (
                          <>
                            <img
                              src={sign}
                              alt="Signature"
                              className="img-fluid d-block mb-1"
                              style={{ maxHeight: '60px' }}
                            />
                            <div><strong>{signature_title}</strong></div>
                          </>
                        ) : (
                          <span className="text-muted">No Signature</span>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <SettingContainer title="School Profile" icon="fa fa-briefcase" Menu={menu}>
      <ProfileCard />
    </SettingContainer>
  );
};

export default SchoolProfile;